import React from 'react';
import { styled } from '@mui/material/styles';
import { Card, CardContent, Grid } from '@mui/material';
import clsx from 'clsx';
import Typography from '@mui/material/Typography';
const PREFIX = 'TariffCard';

const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`,
  title: `${PREFIX}-title`,
  avatar: `${PREFIX}-avatar`,
  icon: `${PREFIX}-icon`,
  difference: `${PREFIX}-difference`,
  differenceIcon: `${PREFIX}-differenceIcon`,
  differenceValue: `${PREFIX}-differenceValue`,
};

const StyledCard = styled(Card)(({ theme }) => ({
  [`&.${classes.root}`]: {
    height: '100%',
  },

  [`& .${classes.content}`]: {
    alignItems: 'center',
    display: 'flex',
  },

  [`& .${classes.title}`]: {
    fontWeight: 700,
  },

  [`& .${classes.avatar}`]: {
    backgroundColor: theme.palette.error.main,
    height: 56,
    width: 56,
  },

  [`& .${classes.icon}`]: {
    height: 32,
    width: 32,
  },

  [`& .${classes.difference}`]: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.differenceIcon}`]: {
    color: theme.palette.error.dark,
  },

  [`& .${classes.differenceValue}`]: {
    color: theme.palette.error.dark,
    marginRight: theme.spacing(1),
  },
}));

const TariffCard = props => {
  const { tariff, className, ...rest } = props;

  return (
    <StyledCard {...rest} className={clsx(classes.root, className)}>
      <CardContent>
        <Grid container justifyContent='space-between'>
          <Grid>
            <Typography className={classes.title} color='textSecondary' gutterBottom variant='body2'>
              {tariff.name}
            </Typography>
            <Typography variant='h3'>{tariff.price} руб.</Typography>
          </Grid>
        </Grid>
        <div className={classes.difference}>
          <Typography className={classes.caption} variant='caption'>
            {tariff.description}
          </Typography>
        </div>
      </CardContent>
    </StyledCard>
  );
};

TariffCard.propTypes = {};

export default TariffCard;
